export class AddressHelper {
	addressHelperUrl = 'https://addressservice.fairweben.de/list?pageSize=200&page=1'
	queryDelay = 500 //ms
	delayTimer = null

	processAddress = async (postcode, city, street, fillAddress, addHints, invalidateAddress, streetContainsNumber, callbackOnFill) => {
		if (postcode.length + city.length + street.length < 4) {
			return
		}
		// Separate number
		let streetName
		let streetNumber
		if (streetContainsNumber) {
			const match = street.match(/([a-zäöüß\-\s]*[a-zäöüß])(\s*\d*\s*[a-z]?\s*-?\s*[a-z]?)?/i) // (\s?\-\s?\d+\w?)
			streetName = match && match.length > 1 ? match[1] : ''
			streetNumber = match && match.length > 2 && match[2] ? match[2] : ''
		}
		else {
			streetName = street
			streetNumber = ''
		}
		const resp = await fetch(this.addressHelperUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json; charset=UTF-8'
			},
			body: `{
			"zip":{"zip":"${postcode}"},
			"city":{"name":"${city}"},
			"street":{"name":"${streetName}"}
		}`
		})
		const json = await resp.json()
		console.debug('Matching addresses: ', json)
		if (json.length === 1) {
			fillAddress(json[0].zip.zip, json[0].city.name, json[0].street.name + streetNumber, callbackOnFill)
		}
		else if (json.length > 1) {
			invalidateAddress()
			addHints(
				[...new Set(json.map(a => a.zip.zip))],
				[...new Set(json.map(a => a.city.name))].sort(),
				[...new Set(json.map(a => a.street.name + streetNumber))]
			)
		}
		else {
			invalidateAddress()
		}
	}

	/**
	 * Add a dropdown with appropriate alternatives right after th input
	 * @param {*} input The input
	 * @param {*} values Choice of value
	 * @param {*} selectorId An ID for the temporary select
	 * @param {*} afterSelection A function bo be called on selection
	 */
	addHint = (input, values, selectorId, afterSelection) => {
		const selector = '#' + selectorId
		// Delete old select
		input.parentElement.querySelectorAll(selector).forEach(e => e.remove())
		// Apply value if there is only a single choice
		if (values.length === 1) {
			input.value = values[0]
			input.setAttribute('valid', '')
		}
		else if (values.length > 1 && values.length < 50 && !values.includes(input.value)) {
			// User has the choice
			const select = `<select id="${selectorId}" class="address-helper-hint" size="10" style="height: initial;">
				${values.map(v => `<option value="${v}">${v}</option>`)}
			</select>`
			input.parentElement.insertAdjacentHTML('beforeend', select)
			const newSelect = input.parentElement.querySelector(selector)
			// React on selection
			newSelect.addEventListener('change', 
				ev => {
					input.value = ev.target.value
					input.focus()
					newSelect.remove()
					afterSelection()
				}
			)
		}
	}


	/**
	 * Check input key and execute callback delayed. 
	 * Each input restarts the timer.
	 * 
	 * @param {*} keyUpEvent The key up event of the input
	 * @param {*} callback Call delayed after keyboard input but not for Backspace or Delete key
	 * @returns false for Backspace or Delete key. As the callback might reissue the deleted character it can be omitted on character deletion.
	 */
	executeDelayedOnInputKeyUp = (keyUpEvent, callback, invalidateAddress) => {
		// Reset timer on key event
		if (this.delayTimer) {
			clearTimeout(this.delayTimer)
		}
		// Check for deletion
		if (keyUpEvent.key === "Backspace" || keyUpEvent.key === "Delete") {
			invalidateAddress()
			// Do nothing else
			return false
		}
		// Reschedule callback
		this.delayTimer = setTimeout(
			callback,
			this.queryDelay
		)
		return true
	}

	addAddressHelper = (postcodeInput, cityInput, streetInput, numberInput, callbackOnFill) => {
		if (postcodeInput && cityInput && streetInput) {
			postcodeInput.setAttribute('autocomplete', 'new-password')
			cityInput.setAttribute('autocomplete', 'new-password')
			streetInput.setAttribute('autocomplete', 'new-password')
			numberInput.setAttribute('autocomplete', 'new-password')
			postcodeInput.classList.add('address-helper')
			cityInput.classList.add('address-helper')
			streetInput.classList.add('address-helper')
			let streetContainsNumber = true
			if (numberInput && numberInput.length) {
				streetContainsNumber = false
				numberInput.setAttribute('autocomplete', 'new-password')
				numberInput.classList.add('address-helper')
			}
			/**
			 * Callback to apply values to inputs
			 * 
			 * @param {*} postcode The actual value string
			 * @param {*} city The actual value string
			 * @param {*} street The actual value string
			 */
			const fillAddress = (postcode, city, street, callbackOnFill) => {
				postcodeInput.value = postcode
				postcodeInput.setAttribute('valid', '')
				const postcodeHint = postcodeInput.parentElement.querySelector('.address-helper-hint')
				if (postcodeHint) {
					postcodeHint.remove()
				}
				cityInput.value = city
				cityInput.setAttribute('valid', '')
				const cityHint = cityInput.parentElement.querySelector('.address-helper-hint')
				if (cityHint) {
					cityHint.remove()
				}
				streetInput.value = street
				streetInput.setAttribute('valid', '')
				const streetHint = streetInput.parentElement.querySelector('.address-helper-hint')
				if (streetHint) {
					streetHint.remove()
				}
				if (numberInput && numberInput.value) {
					numberInput.setAttribute('valid', '')
				}
				if (callbackOnFill) {
					callbackOnFill()
				}
			}
			/**
			 * Callback to call the addHint function for each input field
			 * @param {*} postcodes List with possible postcodes
			 * @param {*} cities List with possible cities
			 * @param {*} streets List with possible streets (all with pending number)
			 */
			const addHints = (postcodes, cities, streets) => {
				this.addHint(postcodeInput, postcodes, 'postcodes-hint', () => this.processAddress(postcodeInput.value, cityInput.value, streetInput.value, fillAddress, addHints, invalidateAddress, streetContainsNumber, callbackOnFill))
				this.addHint(cityInput, cities, 'cities-hint', () => this.processAddress(postcodeInput.value, cityInput.value, streetInput.value, fillAddress, addHints, invalidateAddress, streetContainsNumber, callbackOnFill))
				this.addHint(streetInput, streets, 'streets-hint', () => this.processAddress(postcodeInput.value, cityInput.value, streetInput.value, fillAddress, addHints, invalidateAddress, streetContainsNumber, callbackOnFill))
			}
			/**
			 * Callback to remove the valid class from all inputs
			 */
			const invalidateAddress = () => {
				postcodeInput.classList.remove('valid')
				cityInput.classList.remove('valid')
				streetInput.classList.remove('valid')
				if (numberInput) {
					numberInput.classList.remove('valid')
				}
			}
			// Process keyboard inputs
			postcodeInput.addEventListener('keyup', ev => {
				this.executeDelayedOnInputKeyUp(ev, () => this.processAddress(ev.target.value, cityInput.value, streetInput.value, fillAddress, addHints, invalidateAddress, streetContainsNumber, callbackOnFill), invalidateAddress)
			})
			cityInput.addEventListener('keyup', ev => {
				this.executeDelayedOnInputKeyUp(ev, () => this.processAddress(postcodeInput.value, ev.target.value, streetInput.value, fillAddress, addHints, invalidateAddress, streetContainsNumber, callbackOnFill), invalidateAddress)
			})
			streetInput.addEventListener('keyup', ev => {
				this.executeDelayedOnInputKeyUp(ev, () => this.processAddress(postcodeInput.value, cityInput.value, ev.target.value, fillAddress, addHints, invalidateAddress, streetContainsNumber, callbackOnFill), invalidateAddress)
			})
			if (numberInput) {
				numberInput.addEventListener('keyup', ev => {
					this.executeDelayedOnInputKeyUp(ev, () => this.processAddress(postcodeInput.value, cityInput.value, streetInput.value, fillAddress, addHints, invalidateAddress, streetContainsNumber, callbackOnFill), invalidateAddress)
				})
			}
		}
	}
}

// Use it like this:
// Apply Address Helper
/*		const addressHelper = new AddressHelper()
		addressHelper.addAddressHelper(document.getElementById('deliveryPostalCode'), document.getElementById('deliveryCity'), document.getElementById('deliveryStreet'), document.getElementById('deliveryNr'), alert('Address complete'))
*/